import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentsSection = () => {
  const documents = [
    { 
      name: 'Statement of Work - Phase 1', 
      type: 'PDF', 
      size: '2.4 MB', 
      date: 'Jan 1, 2025',
      status: 'current',
      description: 'Detailed scope of work for initial project phase'
    },
    { 
      name: 'Technical Specifications', 
      type: 'PDF', 
      size: '1.8 MB', 
      date: 'Dec 28, 2024',
      status: 'current',
      description: 'Technical requirements and system specifications'
    },
    { 
      name: 'Service Level Agreement', 
      type: 'PDF', 
      size: '892 KB', 
      date: 'Dec 28, 2024',
      status: 'current',
      description: 'Performance metrics and service guarantees'
    },
    { 
      name: 'Data Processing Agreement', 
      type: 'PDF', 
      size: '1.2 MB', 
      date: 'Dec 27, 2024',
      status: 'current',
      description: 'Data handling and privacy compliance terms'
    },
    { 
      name: 'Amendment #1 - Scope Extension', 
      type: 'PDF', 
      size: '654 KB', 
      date: 'Dec 20, 2024',
      status: 'archived',
      description: 'Contract modification for additional services'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'current':
        return 'text-success bg-success/10';
      case 'archived':
        return 'text-muted-foreground bg-muted/50';
      default:
        return 'text-muted-foreground bg-muted/50';
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <Icon name="FolderOpen" size={20} className="text-primary" />
            <h2 className="text-xl font-semibold text-foreground">Supporting Documents</h2>
          </div>
          <div className="text-sm text-muted-foreground">
            {documents?.length} documents
          </div>
        </div>
        
        <div className="space-y-3">
          {documents?.map((doc, index) => (
            <div key={index} className="flex items-center justify-between p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors duration-150">
              <div className="flex items-center space-x-4 flex-1">
                <div className="flex-shrink-0 p-2 bg-primary/10 rounded-lg">
                  <Icon name="FileText" size={18} className="text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-3 mb-1">
                    <p className="text-base font-medium text-foreground truncate">
                      {doc?.name}
                    </p>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(doc?.status)}`}>
                      {doc?.status}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-1">
                    {doc?.description}
                  </p>
                  <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                    <span>{doc?.type}</span>
                    <span>•</span>
                    <span>{doc?.size}</span>
                    <span>•</span>
                    <span className="font-mono">{doc?.date}</span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 ml-4">
                <button className="p-2 text-muted-foreground hover:text-primary transition-colors duration-150 rounded-lg hover:bg-primary/10">
                  <Icon name="Eye" size={16} />
                </button>
                <button className="p-2 text-muted-foreground hover:text-primary transition-colors duration-150 rounded-lg hover:bg-primary/10">
                  <Icon name="Download" size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Upload" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Document Actions</h3>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button className="flex items-center space-x-3 p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors duration-150">
            <Icon name="Upload" size={18} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Upload Document</span>
          </button>
          <button className="flex items-center space-x-3 p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors duration-150">
            <Icon name="Archive" size={18} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Archive Selected</span>
          </button>
          <button className="flex items-center space-x-3 p-4 border border-border rounded-lg hover:bg-muted/30 transition-colors duration-150">
            <Icon name="Share" size={18} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Share Documents</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentsSection;